import React from 'react';

interface ProfilePictureProps {
  firstName: string;
  profileColor: string;
  size?: 'sm' | 'md' | 'lg' | 'xl';
  className?: string;
}

const ProfilePicture: React.FC<ProfilePictureProps> = ({ 
  firstName, 
  profileColor, 
  size = 'md', 
  className = '' 
}) => {
  const sizeClasses = {
    sm: 'w-8 h-8 text-sm',
    md: 'w-12 h-12 text-base',
    lg: 'w-16 h-16 text-xl',
    xl: 'w-20 h-20 text-2xl'
  };

  const initial = firstName.charAt(0).toUpperCase() || 'U';

  return (
    <div 
      className={`${sizeClasses[size]} rounded-full border-2 border-gray-200 flex items-center justify-center text-white font-bold shadow-sm ${className}`}
      style={{ backgroundColor: profileColor }}
    >
      {initial}
    </div>
  );
};

export default ProfilePicture;